import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-management-layout',
  templateUrl: './user-management-layout.component.html',
  styleUrl: './user-management-layout.component.scss'
})
export class UserManagementLayoutComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) subTitle: string;
  @Input({ required: true }) bgColor: string; // as #color
  @Input({ required: true }) imgUrl: string;

}
